import { useEffect, useState } from 'react';
import './LandingCameraPermissionDenied.scss';

export default function LandingCameraPermissionDenied({ onContinue, onRetry }) {
  const [permissionStatus, setPermissionStatus] = useState('prompt');

  useEffect(() => {
    // Verificar el estado de los permisos de cámara
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'camera' }).then((result) => {
        setPermissionStatus(result.state);
        
        // Escuchar cambios en el estado de permisos
        result.onchange = () => {
          setPermissionStatus(result.state);
        };
      }).catch(() => {
        // Si la API no está disponible, asumimos 'prompt'
        setPermissionStatus('prompt');
      });
    }
  }, []);

  const handleRetry = async () => {
    if (onRetry) {
      await onRetry();
    } else {
      // Si no hay callback, intentar refrescar la página
      window.location.reload();
    }
  };

  const getHintText = () => {
    if (permissionStatus === 'denied') {
      return '(To enable camera access, please update your browser settings and refresh the page)';
    }
    return '(Or refresh and allow camera access to experience the journey fully)';
  };

  return (
    <div className="landing-camera-permission-denied">
      <div className="landing-camera-permission-denied__logo">
        <img src="/images/logo.png" alt="Joby" />
      </div>

      <div className="landing-camera-permission-denied__content">
        <h1 className="landing-camera-permission-denied__title">
          That's okay.
          <br />
          You can keep exploring.
        </h1>

        <p className="landing-camera-permission-denied__description">
          Camera access unlocks the full experience, but you can continue with a preview of what urban travel could feel like, without the street below.
        </p>

        <p className="landing-camera-permission-denied__hint">
          {getHintText()}
        </p>

      </div>
      <div className="landing-camera-permission-denied__buttons">
        {permissionStatus !== 'denied' && onRetry && (
          <button
            className="landing-camera-permission-denied__button landing-camera-permission-denied__button--secondary"
            onClick={handleRetry}
          >
            Try again
          </button>
        )}
        <button
          className="landing-camera-permission-denied__button"
          onClick={onContinue}
        >
          Continue without permission
        </button>
      </div>
    </div>
  );
}
